export const formatPhoneNumber = (phone: any) => {
  phone = phone.replace(/\D/g, "");
  const len = phone.length;
  return len === 10 ? phone : phone.substring(len - 10, len); 
};

export const formatCognitoPhoneNumber = (phone: any, countryCode = "+1") => {
  const formatted = formatPhoneNumber(phone);
  return `${countryCode}${formatted}`;
};

export const formatPhoneString = (val: any) => {
  val = formatPhoneNumber(val);
  const x = val.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  const formatted = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  return formatted;
};
